import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=6ffaefc9&scoped=true&"
import script from "./OrderDetail.vue?vue&type=script&lang=js&"
export * from "./OrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=6ffaefc9&prod&lang=scss&scoped=true&"
import style1 from "./OrderDetail.vue?vue&type=style&index=1&id=6ffaefc9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffaefc9",
  null
  
)

export default component.exports